var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.334A5.333 5.333 0 108 2.667a5.333 5.333 0 000 10.667zm0 1.333A6.667 6.667 0 108 1.334a6.667 6.667 0 000 13.333z",
    fill: "#6A36FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.524 5.429c.368 0 .667.298.667.666v2.19h2.19a.667.667 0 110 1.334H7.524a.667.667 0 01-.667-.666V6.095c0-.368.299-.666.667-.666z",
    fill: "#6A36FF"
  })));
}

export default SvgClock16;